module.exports = __webpack_public_path__ + "img/micronesia.2fce4e9b.png";